import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateAttributeTypeBindDto {
    @Expose()
    readonly type_id: number;

    @Expose()
    readonly attribute_type_name: string;
}
